import { ToastCustom } from "@components";
import { AxiosError } from "axios";
import { toast } from "sonner";
import { useInfractionsSignInMutation } from "../query";

export const useInfractionsSignIn = () => {
	const { mutate, isPending } = useInfractionsSignInMutation();

	const openHabilitarMeInNewTab = () => {
		if (isPending) {
			return;
		}

		mutate(undefined, {
			onSuccess: (redirectUrl) => {
				window.open(redirectUrl, "_blank", "noopener,noreferrer");
			},
			onError: (error) => {
				if (error instanceof AxiosError) {
					const errorData = error.response?.data;
					if (
						errorData?.error?.errors?.length > 0 ||
						errorData?.error?.detail
					) {
						const errorMessages =
							errorData?.error?.errors[0] || errorData?.error?.detail;
						toast(
							ToastCustom({
								description: errorMessages,
								title: "Erro ao abrir Infrações",
							})
						);
						return;
					}
				}

				toast(
					ToastCustom({
						description:
							"Não foi possível acessar o Infrações. Tente novamente.",
						title: "Erro ao abrir Infrações",
					})
				);
			},
		});
	};

	return {
		signInHabilitarMe: mutate,
		openHabilitarMeInNewTab,
		isSigningInHabilitarMe: isPending,
	};
};
